import { render, staticRenderFns } from "./CategoriasEAtos.vue?vue&type=template&id=b4f9fbb8&"
import script from "./CategoriasEAtos.vue?vue&type=script&lang=js&"
export * from "./CategoriasEAtos.vue?vue&type=script&lang=js&"
import style0 from "./CategoriasEAtos.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports